export default __webpack_public_path__ + "static/media/11-12.0cd665c2.png";